import React from "react";

import RuleComponent from "../ruleComponent";

const RulesLevel = ({ classes,rulesArr  }) => {



  return (
    <div className="col-lg-6">
      <div className={classes.formCard}>
        <div className={classes.formGrid}>
          {rulesArr.map((rule) => (
           <RuleComponent key={rule.id} rule={rule} rulesArr={rulesArr} classes={classes}/>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RulesLevel;
